'use strict';

// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  PickupLocation
// -----------------------------------------------------------
const PickupLocation = ({location}) => {
  const rows = location.address.rows || [location.address.city, location.address.street];

  return(
    <div>
      <strong>{ rows[0] }</strong>
      <br />
      {
        rows.slice(1).map((row, i) => {
          return <span key={ i }>{ row } <br /></span>;
        })
      }
    </div>
  )
};

export default PickupLocation;
